import { Directive } from '@angular/core';

/**
 * Directive for displaying a custom placeholder on the dropdown before something was selected.
 * This allows for consumers to specify a custom placeholder label but it has no code,
 * it only acts as a content projection slot for the dropdown component
 *
 * @example
 * <td-wb-dropdown>
      <td-wb-dropdown-placeholder>
        <td-wb-icon iconId="avatar"></td-wb-icon>&nbsp;
        <span>Custom select message:</span>
      </td-wb-dropdown-placeholder>
      @for (securityType of securityTypes; track securityType) {
       <td-wb-dropdown-item [value]="securityType">
        <span>{{ securityType }}</span>
       </td-wb-dropdown-item>
      }
    </td-wb-dropdown>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'td-wb-dropdown-placeholder'
})
export class DropdownPlaceholderDirective {
}
